import { Injectable, Inject } from '@angular/core';
import { Observable ,  ReplaySubject } from 'rxjs';
import { PrenoteHistoryFilters } from './prenote-history-filters.model';

@Injectable()
export class PrenoteHistoryFiltersService {
  private subject: ReplaySubject<PrenoteHistoryFilters>;
  private _lastFilters: PrenoteHistoryFilters;

  private _suppressUpdate = false;

  constructor() {
    this.subject = new ReplaySubject<PrenoteHistoryFilters>(1);
    if (!this._suppressUpdate) {
      if (this._lastFilters) {
        this.updateFilters(this._lastFilters.copy());
      } else {
        this.updateFilters(this.createDefaultFilter());
      }
    }
  }

  updateFilters(filters: PrenoteHistoryFilters) {
    this._lastFilters = filters;
    this.subject.next(filters);
  }

  clearFilters() {
    if (this._lastFilters) {
      this._lastFilters.reset();
    }
  }

  getFilters(): Observable<PrenoteHistoryFilters> {
    return this.subject.asObservable();
  }

  createDefaultFilter(): PrenoteHistoryFilters {
    return new PrenoteHistoryFilters(
      [],
    );
  }
}
